import { z } from "zod";

export default {
  params: z.object({
    email: z.email(),
  }),
  response: z.void(),
};
